<style scoped>
.content-wrapper .content {
  padding-top: 95px;
}

.el-select {
  display: block;
}
.el-button--success:focus, .el-button--success:hover{
  background: rgba(200,200,200,2.3);
  border-color:rgba(200,200,200,2.3);
}
</style>
<template>
  <!-- <transition name="el-zoom-in-top"> -->
  <div class="content-wrapper">
    <section class="content">
      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Edit Domain.. ({{ name }})</h3>
        </div>
        <div class="box-body">
          <form
            method="post"
            v-on:submit.prevent="onSubmit"
            class="form"
            v-loading="loading"
          >
            <h5>Publisher</h5>
            <!-- <p>Choose publisher from the dropsown or create one by clicking +add publisher</p> -->
            <div class="row">
              <div class="col-md-9">
                <el-select v-model="publisherId" filterable placeholder="Select" @change="$event=> setPubId()">
                  <el-option
                    v-for="pub in publishers"
                    :key="pub.name"
                    :label="pub.name"
                    :value="pub.id"
                  >
                  </el-option>
                </el-select>
                <!-- <el-input :disabled="true" v-model="pubName"></el-input>        -->
              </div>
            </div>
            <hr />
            <div v-if="!mcm_enabled">
              <h5>DFP Network</h5>
              <div class="row">
                <div class="col-md-9">
                  <el-select
                    v-model="pubdetailistid"
                    filterable
                    placeholder="Select"
                  >
                    <el-option
                      v-for="dfp in dfpNetworkListAsPerSelectedDfpAccount"
                      :key="dfp.id"
                      :label="dfp.display_name"
                      :value="dfp.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <hr />
            <h5>Domain URL</h5>
            <div class="el-input el-input-group el-input-group--prepend">
              <div tabindex="0" class="el-input-group__prepend">
                {{ !isSecure ? "http://" : "https://" }}
              </div>
              <el-input
                class=""
                v-validate="'required'"
                data-vv-delay="200"
                :class="{ input: true, 'is-danger': errors.has('name') }"
                name="name"
                type="text"
                placeholder="Domain URL"
                v-model="name"
              ></el-input>
            </div>
            <span v-show="errors.has('name')" class="help is-danger">{{
              errors.first("name")
            }}</span>
            <hr />
            <div class="row">
              <div class="col-md-9">
                      <h5>Is MCM Enabled?</h5>
                      <el-switch active-text="" inactive-text="" active-color="#13ce66" inactive-color="#ff4949" v-model="mcm_enabled" @change="resetMCM">Is sticky Unit?</el-switch>
              </div>
            </div>
             <div class="row" v-if="mcm_enabled">
                  <div class="col-md-6" style="">
                    <h5>Select DFP Account</h5>
                    <el-select v-model="dfp_credentials" filterable placeholder="Select a DFP" @change="filterNetworkList">
                        <!-- <el-option key="" label="Select a DFP" value=""></el-option> -->
                        <el-option v-for="item in dfpAccounts" :key="item.id" :label="item.alias_name" :value="item.id">
                        </el-option>
                    </el-select>
                    </div>
                    <div class="col-md-6" style="" v-if="dfp_credentials != undefined">
                        <h5>Select Parent DFP Network</h5>
                        <el-select v-model="dfp_network" filterable placeholder="Select a Parent DFP Network" @change="filterNetworkList">
                            <!-- <el-option key="" label="Select a DFP Network" value=""></el-option> -->
                            <el-option v-for="network in getDfpNetworks(dfp_credentials)" :key="network.id" :label="`${network.network_code +' : ' + network.display_name}`" :value="network.id">
                            </el-option>
                        </el-select>
                    </div>
            </div>
            <div class="row" v-if="mcm_enabled">
            <div class="col-md-6">
                    <h5>Select MCM Delegation Type:</h5>
                    <el-select v-model="account_type" placeholder="Select MCM Delegation Type" @change="filterNetworkList">
                            <el-option v-for="(mcm_account_type,id) in mcmAccountType" :data-id="id" :label="mcm_account_type.account_type.replaceAll('_',' ')" :value="mcm_account_type.id" :key="id">
                            </el-option>
                    </el-select>
                    </div>
                    <div class="col-md-6">
                        <h5>Select Child DFP Network</h5>
                        <el-select :disabled="account_type==null" v-model="child_dfp_network" filterable placeholder="Select Child DFP Network">
                            <!-- <el-option key="" label="Select a DFP Network" value=""></el-option> -->
                            <el-option v-for="network in filteredAccountList" :key="network.id" :label="`${network.child_network_code +' : ' + network.name}`" :value="network.id">
                            </el-option>
                        </el-select>
                    </div>
                    </div>
            <hr />
            <div class="row">
              <div class="col-md-6">
                <h5>Display parent ad unit id</h5>
                <el-input
                  placeholder="parent_ad_unit_id "
                  v-model="parent_ad_unit_id"
                ></el-input>
              </div>
              <div class="col-md-6">
                <h5>Display parent ad unit code</h5>
                <el-input
                  placeholder="parent_ad_unit_code "
                  v-model="parent_ad_unit_code"
                ></el-input>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6">
                <h5>AMP parent ad unit id</h5>
                <el-input
                  placeholder="amp_parent_ad_unit_id "
                  v-model="amp_parent_ad_unit_id"
                ></el-input>
              </div>
              <div class="col-md-6">
                <h5>AMP parent ad unit code</h5>
                <el-input
                  placeholder="amp_parent_ad_unit_code "
                  v-model="amp_parent_ad_unit_code"
                ></el-input>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6">
                <h5>Assertive Yield id</h5>
                <el-input
                  placeholder="get this from Assertive Yield's website"
                  v-model="assertive_yield_id"
                ></el-input>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6">
                <h5>Ad Lightning Script Tag</h5>
                <el-input
                  placeholder="Enter Ad Lightning Script Tag"
                  v-model="ad_lightnings_script_tag"
                ></el-input>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6">
                <h5>Fouanalytics Script Tag</h5>
                <el-input
                  placeholder="Enter Fouanalytics Script Tag"
                  v-model="fouanalytics_script_tag"
                ></el-input>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-4">
                <el-checkbox v-model="isSecure">Secure site?</el-checkbox>
              </div>
              <!-- <div class="col-md-6">

<el-checkbox v-model="publisherDFP">Publisher DFP?</el-checkbox>

</div> -->
              <div class="col-md-4">
                <el-checkbox v-model="infinite_scroll"
                  >Infinite Scroll?</el-checkbox
                >
              </div>
              <div class="col-md-4">
                <el-checkbox v-model="seller_json"
                  >Ignore in Sellers.json?</el-checkbox
                >
              </div>
            </div>
            <hr />
            <h5>Seller Id Domain</h5>
            <div class="row">
                <div class="col-md-9">
                    <el-select v-model="seller_domain_id" placeholder="Select" filterable>
                        <el-option
                            v-for="seller in sellers"
                            :key="seller.domain_name"
                            :label="seller.domain_name"
                            :value="seller.domain_id"
                            :loading="sellerLoading"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <hr />
            <div class="clearfix">
              <button type="submit" class="el-button el-button--info" :disabled="(mcm_enabled)? account_type==null && child_dfp_network==null :false">
                <i class="el-icon-edit el-icon-left"></i>
                Update Domain
              </button>
              <button type="button" @click="migrateToMCM" class="el-button el-button--success" :disabled="account_type==null&&child_dfp_network==null">
                <i class="el-icon-upload el-icon-left"></i>
                Migrate Domain
              </button>
              <router-link
                to="/admin/domains/"
                class="el-button el-button--danger"
              >
                Cancel
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
  <!-- </transition> -->
</template>
<script>
import axios from "axios";
export default {
  data: () => {
    return {
      mcm_enabled:false,
      ad_lightnings_script_tag: "",
      fouanalytics_script_tag: "",
      dfpAccounts: [],
      dfp_credentials: undefined,
      uuid: undefined,
      domId: undefined,
      domainId: undefined,
      publisherId: undefined,
      pubName: undefined,
      name: undefined,
      dfpCredId: undefined,
      child_dfp_network:null,
      dfp_network: undefined,
      childDfpAccounts:[],
      mcmAccountType:[],
      account_type:null,
      pubdetaillist: [],
      pubdetailistid: "",
      pubdetaillistname: "",
      parent_ad_unit_id: undefined,
      parent_ad_unit_code: undefined,
      amp_parent_ad_unit_id: undefined,
      amp_parent_ad_unit_code: undefined,
      dfpNetworkListAsPerSelectedDfpAccount: [],
      assertive_yield_id: undefined,
      publishers: [],
      isSecure: true,
      publisherDFP: false,
      infinite_scroll: true,
      seller_json: false,
      loading: true,
      filteredAccountList:[],
      seller_domain_id: null,
      sellerLoading: true
    };
  },
  created: function () {
    this.uuid = this.$route.params.uuid;
    this.domId = this.$route.params.domId;

    axios
      .all([
        axios.get(BASE_URL + "v1/publishers/"),
        axios.get(
          BASE_URL +
            "v1/publishers/" +
            this.uuid +
            "/domains/" +
            this.domId +
            "/"
        ),
        axios.get(BASE_URL + "v1/dfp_accounts/"),
        axios.get(BASE_URL + 'v1/child-dfp-network-list/'),
        axios.get(BASE_URL + 'v1/mcm-account-list/'),
      ])
      .then(
        axios.spread((publisher, domDetails, dfpaccounts,childAccounts,mcm_type) => {
          console.log(domDetails, this.domId)
          //console.log("dfpaccounts",dfpaccounts.data);
          //console.log("domDetailslist",domDetails);

          this.pubdetaillist = dfpaccounts.data;
          this.pubdetailistid = domDetails.data.dfp_network.id;
          this.childDfpAccounts = childAccounts.data
          this.mcmAccountType = mcm_type.data
          this.dfpAccounts = this.pubdetaillist;

          var selectedDFPAcoountId = domDetails.data.dfp_credentials.id;

          ////console.log("name of existing selected",this.pubdetaillistname);
          ////console.log("length of dfpaccounts",dfpaccounts.data.length,"type",typeof dfpaccounts.data);

          var dp = dfpaccounts.data;

          for (var i = 0; i < dp.length; i++) {
            if (selectedDFPAcoountId == dp[i].id) {
              ////console.log("dfpaccounts +",i ,"=",dp[i]);
              this.dfpNetworkListAsPerSelectedDfpAccount = dp[i].networks;
              break;
            }

            ////console.log("-----------------------------------");
          }

          ////console.log("networs", this.dfpNetworkListAsPerSelectedDfpAccount.length);

          // console.log("res pubdetail",domDetails.data);

          this.publishers = publisher.data.pub_data;
          //////console.log(domDetails.data.id);
          //////console.log(domDetails.data.publisher.name);
          // this.domainId = domDetails.data.pub_id;
          this.domainId = domDetails.data.id; //Changing Value
          this.name = domDetails.data.name;
          this.pubName = domDetails.data.publisher.name;
          this.parent_ad_unit_id = domDetails.data.parent_ad_unit_id;
          this.parent_ad_unit_code = domDetails.data.parent_ad_unit_code;
          this.amp_parent_ad_unit_id = domDetails.data.amp_parent_ad_unit_id;
          this.amp_parent_ad_unit_code =
            domDetails.data.amp_parent_ad_unit_code;
          this.infinite_scroll = domDetails.data.infinite_scroll;
          this.dfp_network = domDetails.data.dfp_network.id;
          this.isSecure = domDetails.data.is_secure;
          this.publisherDFP = domDetails.data.publishers_dfp;
          this.dfpCredId = domDetails.data.dfp_credentials;
          this.dfp_credentials = this.dfpCredId.id
          this.account_type = (domDetails.data.mcm_enable)?domDetails.data.mcm.id:this.account_type
          this.mcm_enabled = domDetails.data.mcm_enable
          this.child_dfp_network = (domDetails.data.mcm_enable)?domDetails.data.child_dfp_network.id:this.child_dfp_network
          this.assertive_yield_id = domDetails.data.assertive_yield_id;
          this.seller_json = domDetails.data.sellers_json_disabled;
          this.publisherId = domDetails.data.publisher.id;
          this.getSellerId();
          this.initialPublisherId = domDetails.data.publisher.id;
          this.seller_domain_id = domDetails.data.seller_id_input
          this.ad_lightnings_script_tag =
            domDetails.data.ad_lightnings_script_tag;
          this.fouanalytics_script_tag =
            domDetails.data.fouanalytics_script_tag;
          var selectedAccount = (domDetails.data.mcm_enable)?this.mcmAccountType.filter(k=>{return k.id==this.account_type})[0].account_type:''
          this.filteredAccountList = (domDetails.data.mcm_enable)?this.childDfpAccounts.filter(k=>{return (k.delegation_type == selectedAccount && k.dfp_network == this.pubdetailistid)}):this.childDfpAccounts
          // console.log(
          //   this.filteredAccountList, selectedAccount, 'pppppp',this.dfp_network
          // )
          this.loading = false;
        })
      );
  },
  methods: {
    setPubId(){
        this.getSellerId();
    },
    getSellerId() {
        this.seller_domain_id = null;
        this.sellerLoading = true;
        console.log('seller called');
        axios
            .post(BASE_URL + 'reports/v1/pub-get-dash-info/', {
                publisherId: this.publisherId,
            })
            .then((response) => {
                if (response.data.status) {
                    this.sellers = response.data.data;
                }
                this.sellerLoading = false;
            })
            .catch((err) => {
                console.log('err', err);
            });
    },

    filterNetworkList(){
          if(this.account_type && this.dfp_network){
            var selectedAccount = this.mcmAccountType.filter(k=>{return k.id==this.account_type})[0].account_type
            this.filteredAccountList = this.childDfpAccounts.filter(k=>{return (k.delegation_type == selectedAccount && k.dfp_network == this.dfp_network)})
            this.child_dfp_network=null
          }
        },
    onSubmit() {
      axios
        .put(
          BASE_URL +
            "v1/publishers/" +
            this.uuid +
            "/domains/" +
            this.domId +
            "/",
          {
            fouanalytics_script_tag: this.fouanalytics_script_tag,
            ad_lightnings_script_tag: this.ad_lightnings_script_tag,
            name: this.name,
            is_secure: this.isSecure,
            publisher: this.publisherId,
            mcm:this.account_type,
            mcm_enable:(this.account_type!=null)?true:false,
            child_dfp_network:this.child_dfp_network,
            // publisher: this.publishers,
            publishers_dfp: this.publisherDFP.id,
            parent_ad_unit_id: this.parent_ad_unit_id,
            parent_ad_unit_code: this.parent_ad_unit_code,
            amp_parent_ad_unit_id: this.amp_parent_ad_unit_id,
            amp_parent_ad_unit_code: this.amp_parent_ad_unit_code,
            dfp_credentials: this.dfp_credentials,
            dfp_network: (this.account_type!=null)?this.dfp_network:this.pubdetailistid,
            infinite_scroll: this.infinite_scroll,
            sellers_json_disabled: this.seller_json,
            assertive_yield_id: this.assertive_yield_id,
            seller_id_input: this.seller_domain_id
          }
        )
        .then((response) => {
          this.$notify({
            title: "Success",
            message: "Yay! the domain data has been updated.",
            type: "success",
          });
          setTimeout(() => {
            if (this.initialPublisherId == this.publisherId) {
              this.$router.push(
                `/admin/publisher/${this.uuid}/domain/edit/${this.domId}/`
              );
            } else {
              this.$router.push("/admin/domains");
            }
          }, 1000);
        })
        .catch((error) => {
          this.$notify({
            title: "Warning",
            message: "Shit! Something went wrong.",
            type: "warning",
          });
        });
    },
    linkDFP() {
      axios
        .get(
          BASE_URL +
            "v1/publishers/" +
            this.uuid +
            "/domains/" +
            this.domId +
            "/get_dfp_auth_link/"
        )
        .then((response) => {
          window.location = response.data.authorization_url;
        })
        .catch((error) => {
          //////console.log(error);
        });
    },
    getDfpNetworks(dfp_credentials_id) {
            // //console.log(dfp_credentials_id);
            // //console.log(this.dfpAccounts);
            if (dfp_credentials_id) {
                for (let i = 0; i < this.dfpAccounts.length; i++) {
                    if (dfp_credentials_id == this.dfpAccounts[i].id) {
                        //console.log(this.dfpAccounts[i].networks);
                        let dfp_networks = [];
                        for (let j = 0; j < this.dfpAccounts[i].networks.length; j++) {
                            //console.log(this.dfpAccounts[i].networks[j]);
                            if (this.dfpAccounts[i].networks[j].hb_setup_done) dfp_networks.push(this.dfpAccounts[i].networks[j]);
                        }
                        //console.log(dfp_networks);
                        return dfp_networks;
                    }
                }
            } else {
                return [];
            }
      },
    migrateToMCM(){
      var selectedAccount = this.mcmAccountType.filter(k=>{return k.id==this.account_type})[0].account_type
      var targetDfp = (selectedAccount=='MANAGE_ACCOUNT')?this.child_dfp_network:this.pubdetailistid
      axios
        .put(
          BASE_URL +
            "v1/publishers/" +
            this.uuid +
            "/domains/" +
            this.domId +
            "/",
          {
            // pub_id: this.domainId,
            fouanalytics_script_tag: this.fouanalytics_script_tag,
            ad_lightnings_script_tag: this.ad_lightnings_script_tag,
            name: this.name,
            is_secure: this.isSecure,
            publisher: this.publisherId,
            mcm:this.account_type,
            mcm_enable:(this.account_type!=null)?true:false,
            child_dfp_network:this.child_dfp_network,
            // publisher: this.publishers,
            publishers_dfp: this.publisherDFP.id,
            parent_ad_unit_id: this.parent_ad_unit_id,
            parent_ad_unit_code: this.parent_ad_unit_code,
            amp_parent_ad_unit_id: this.amp_parent_ad_unit_id,
            amp_parent_ad_unit_code: this.amp_parent_ad_unit_code,
            dfp_credentials: this.dfp_credentials,
            dfp_network: this.dfp_network,
            infinite_scroll: this.infinite_scroll,
            sellers_json_disabled: this.seller_json,
            assertive_yield_id: this.assertive_yield_id,
          }
        )
        .then((response) => {
      axios
        .post(
          BASE_URL +
            "v1/mcm-migration/domain/" +
            this.domId +
            "/dfp-network/"+targetDfp,
          {}
        ).then((response) => {
          this.$notify({
            title: "Success",
            message: "Domain Migration Initiated",
            type: "success",
          });
          setTimeout(() => {
            if (this.initialPublisherId == this.publisherId) {
              this.$router.push(
                `/admin/publisher/${this.uuid}/domain/edit/${this.domId}/`
              );
            } else {
              this.$router.push("/admin/domains");
            }
          }, 1000);
        })
        .catch((error) => {
          this.$notify({
            title: "Warning",
            message: "Something went wrong. Try again in sometime",
            type: "warning",
          });
        });
        }).catch((error) => {
          this.$notify({
            title: "Warning",
            message: "Something went wrong. Try again in sometime",
            type: "warning",
          });
        });
    },
    resetMCM(){
        this.dfp_credentials = this.dfpCredId.id
        this.dfp_network = this.pubdetailistid
        this.account_type = null
        this.child_dfp_network=null
      },
  },
  computed: {
    _get_user() {
      // return this.$auth.user() || {};
      let token = window.localStorage && localStorage["default_auth_token"];
      if (token) {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );

        return JSON.parse(jsonPayload);
      } else return undefined;
    },
    hasAccess() {
      return [3, 8, 41, 155, 310].includes(
        this._get_user && this._get_user.user_id
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// EditDomain.vue?5bdc047d